<template>
    <v-dialog v-model="exibirModalEditarPassosWebCheckin" width="1000" max-width="80vw">
        <v-card style="max-width: 100%">
             <v-toolbar color="blue" class="mb-8">
                <v-flex  style="display: flex" class="pa-2">
                    <span style="width:95%;color:white;font-weight:bold;" >
                        Editar Passos do Web Checkin
                    </span>
                    <span style="width:5%">
                        <BotaoTutorial style="margin-right:30px;" urlVideo="" categoria="" legenda="Dúvidas Passos do Web Checkin"/>
                    </span>
                    <span style="width:5%"> 
                        <v-btn x-small color="red" @click="setModalPassosWebCheckin()" title="Fechar">
                            <v-icon x-small style="color:white;">mdi-close</v-icon>
                        </v-btn>
                    </span>
                </v-flex>
            </v-toolbar>

            <v-card-text>

                    <v-container class="">
                        <v-row>
                            <v-col>
                                <div style="font-size: 16px;display:flex;justify-content:flex-start;align-items:center;padding:0px;margin:0px;" >
                                    <v-switch hide-details v-model="exibirPassosCovid" data-cy="exibirPassosCovid" style="border-radius:5px;padding:0px;margin:0px;"></v-switch>
                                    <label style="padding:0px;margin:0px;" >Exibir Passo <b>Formulario Covid</b> ?</label>  
                                </div>
                            </v-col>
                            <v-col>
                                <div style="font-size: 16px;display:flex;justify-content:flex-start;align-items:center;padding:0px;margin:0px;" >
                                    <v-switch hide-details v-model="exibirPassosObservacao" data-cy="exibirPassosObservacao" style="border-radius:5px;padding:0px;margin:0px;"></v-switch>
                                    <label style="padding:0px;margin:0px;" >Exibir Passo <b>Observação</b> ?</label>  
                                </div>
                            </v-col>
                            <v-col>
                                <div style="font-size: 16px;display:flex;justify-content:flex-start;align-items:center;padding:0px;margin:0px;" >
                                    <v-switch hide-details v-model="exibirPassosHorario" data-cy="exibirPassosHorario" style="border-radius:5px;padding:0px;margin:0px;"></v-switch>
                                    <label style="padding:0px;margin:0px;" >Exibir Passo <b>Horário</b> ?</label>  
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <div style="font-size: 16px;display:flex;justify-content:flex-start;align-items:center;padding:0px;margin:0px;" >
                                    <v-switch hide-details v-model="finalizarFicha" data-cy="finalizarFicha" style="border-radius:5px;padding:0px;margin:0px;"></v-switch>
                                    <label style="padding:0px;margin:0px;" >Finalizar Ficha no Web Checkin?</label>  
                                </div>
                            </v-col>
                            <v-col>
                                    <div style="font-size: 16px;display:flex;justify-content:flex-start;align-items:center;padding:0px;margin:0px;" >
                                        <v-switch hide-details v-model="necessidadeSelfie" data-cy="necessidadeSelfie" style="border-radius:5px;padding:0px;margin:0px;"></v-switch>
                                        <label style="padding:0px;margin:0px;" >Enviar uma selfie no web checkin?</label>  
                                    </div>
                            </v-col>
                            <v-col>
                            
                            </v-col>
                        </v-row>
                    </v-container>





                    

                    

                    

                    <div class="cardInputs" style="margin-top:10px;">
                        <label class="labels">Horario Padrão de Checkin / Checkout:</label>
                        <div style="display:flex; flex-direction: column; align-items: flex-start; width: 100%">
                            <div style="display: flex; align-items: strech; width: 100%;">
                                <datetime 
                                    class="inputsHorario" 
                                    value-zone="UTC-3" 
                                    :input-style="{color:'black'}" 
                                    :phrases="{ok: 'OK', cancel: 'CANCELAR'}" 
                                    :minute-step="10" 
                                    format="HH:mm" 
                                    type="time" style="height:60px;"
                                    v-model="horariocheckin" 
                                    data-cy="horariocheckin">
                                </datetime>
                                <textarea 
                                    style="
                                        width: 100%; 
                                        border: 1px solid #819ab4; 
                                        border-radius: 15px;
                                        margin-top: 10px;
                                        resize: none;
                                        padding: 1em;
                                        height:60px;
                                        "
                                    v-model="infohorario.checkin"
                                    maxlength="119"
                                    placeholder="deixe sua informação aqui"/>
                            </div>
                            <div style="display: flex; align-items: strech; width: 100%;">
                                <datetime 
                                    class="inputsHorario" 
                                    value-zone="UTC-3" 
                                    :input-style="{color:'black'}" 
                                    :phrases="{ok: 'OK', cancel: 'CANCELAR'}" 
                                    :minute-step="10"  style="height:60px;"
                                    format="HH:mm" 
                                    type="time" 
                                    v-model="horariocheckout" 
                                    data-cy="horariocheckout">
                                </datetime>
                                <textarea 
                                    style="
                                        width: 100%; 
                                        border: 1px solid #819ab4; 
                                        border-radius: 15px;
                                        margin-top: 10px;
                                        resize: none;
                                        padding: 1em;
                                        height:60px;
                                        "
                                    v-model="infohorario.checkout"
                                    maxlength="119"
                                    placeholder="deixe sua informação aqui"/>
                            </div>
                        </div>
                    </div>


      
                    <div class="cardInputs" style="margin-top:10px;" v-if="tipointegracao == 'HITS'">
                        <label class="labels">Tipo de Observacao Hits</label>
                        <v-select color 
                            v-model="obstipo" 
                            :items="obstipos" 
                            item-text="nome"
                            item-value="idnotetype"
                            return-object
                            outlined style="border-radius:15px;"
                            hide-details label="">
                        </v-select>
                    </div>




                    <div class="cardInputs" style="margin-top:10px;">
                        <label class="labels">Email Adm <span style="font-size:15px!important;">( Recebe Notificações De Web Checkins Realizados)</span></label>
                        <input type="text" class="inputs" v-model="emailAdmWebCheckin" data-cy="emailAdmWebCheckin" placeholder="Informe o email que receberá notificações de webcheckin realizados" />
                    </div>

                    <div class="cardInputs">
                        <label class="labels">Email Adm Secundário <span style="font-size:15px!important;">( Recebe Notificações De Web Checkins Realizados)</span></label>
                        <input type="text" class="inputs" v-model="emailAdmWebCheckinSecundario" data-cy="emailAdmWebCheckinSecundario" placeholder="Informe um segundo email que receberá notificações de webcheckin realizados" />
                    </div>

                    <div class="cardInputs">
                        <label class="labels">Considerar Criança até que idade? </label>
                        <input type="number" class="inputs" v-model="idadelimitecrianca" data-cy="idadelimitecrianca" placeholder="Idade" />
                    </div>

                    <div class="cardInputs">
                        <label class="labels">Assunto do Email do WebCheckin</label>
                        <input type="text" class="inputs" v-model="assuntodowebcheckin" data-cy="assuntodowebcheckin" placeholder="Assunto" />
                        <label class="labels">Texto do Email do WebCheckin</label>
                        <v-textarea outlined name="input-7-4" style="border-radius:10px;" v-model="textodowebcheckin" data-cy="textodowebcheckin"></v-textarea>
                    </div>
                    

                    <div class="cardInputs">
                        <label class="labels">Estilo de Cores Web Checkin? </label>
                        <div style="display: flex; justify-content: space-between">
                            <span data-cy="estilo-span">
                                <label class="labels">Cor Principal</label>
                                <v-color-picker
                                    dot-size="25"
                                    mode="rgba"
                                    swatches-max-height="200"
                                    v-model="corPrincipal"
                                    ref="corPrincipal"
                                    ></v-color-picker>
                            </span>
                            <span data-cy="estilo-span">
                                <label class="labels">Cor Secundária</label>
                                <v-color-picker
                                    dot-size="25"
                                    mode="rgba"
                                    swatches-max-height="200"
                                    v-model="corSecundaria"
                                    ref="corSecundaria"
                                    ></v-color-picker>
                            </span>
                            <span data-cy="estilo-span">
                                <label class="labels">Cor de Fundo</label>
                                <v-color-picker
                                    dot-size="25"
                                    mode="rgba"
                                    swatches-max-height="200"
                                    v-model="corFundo"
                                    ref="corFundo"
                                    ></v-color-picker>
                            </span>
                        </div>
                    </div>

                    <div class="cardInputs">
                        <label class="labels">Botao Webcheckin para Seu Site </label>
                        <span data-cy="botaocor-span">
                            <v-select  outlined style="border-radius:15px;"
                                :items="botaocores" @change="mudarCorBotao(botaocor)"
                                v-model="botaocor" data-cy="botaocor" required>
                            </v-select>
                        </span>
                        <label class="labels">Copie e Cole o Codigo do botão dentro do seu site </label>
                        <v-textarea outlined name="input-7-4" style="" v-model="layoutbotaoselecionado" data-cy="layoutbotaoselecionado"></v-textarea>
                    </div>

                    <div style="display:flex;justify-content:flex-end;margin-top:50px;">
                        <v-btn @click="salvar()" data-cy="salvar" color="primary">
                            {{textobotaosalvar}}
                        </v-btn>
                    </div>

            </v-card-text>
            
                        
            
        </v-card>
    </v-dialog>
</template>          

<script>

import chroma from "chroma-js";
import BotaoTutorial from "../../material/BotaoTutorial.vue";

export default {
    data: () => ({
        tipointegracao:null,
        textoEmail:"Olá @nome, te desejamos um feliz aniversário repleto de felicidades.",
        isImg:null,
        imgSrc:null,
        imgTipo:null, 
        exibirPassosCovid:null,
        exibirPassosObservacao:null,
        exibirPassosHorario:null,
        emailAdmWebCheckin:null,
        emailAdmWebCheckinSecundario:null,
        idadelimitecrianca:null,
        estilos:['AZUL','VERDE','VERMELHO'],
        estilo:'AZUL',
        botaocores:['AZUL','VERDE','VERMELHO'],
        botaocor:'AZUL',
        layoutbotaoselecionado:'AZUL',
        assuntodowebcheckin:null,
        textodowebcheckin:null,
        textobotaosalvar:"SALVAR",
        horariocheckin:null,
        horariocheckout:null,
        finalizarFicha:false,
        necessidadeSelfie: false,
        infohorarioCheckin: null,
        infohorarioCheckout: null,
        infohorario: {
            checkin: null,
            checkout: null
        },
        corPrincipal: null,
        corSecundaria: null,
        corFundo: null,
        obstipos:[],
        obstipo:null,
    }),
    props:["exibirModalEditarPassosWebCheckin"],
    components:{
    BotaoTutorial
},
    watch: {
        corPrincipal: function(){
            this.corSecundaria = chroma.scale([this.corPrincipal.hex, 'white']).colors(6)[2]
            this.corFundo = chroma.scale([this.corSecundaria, 'white']).colors(6)[4]
        }
    },
    methods: {
        mudarCorBotao(cor){

            if(cor == 'AZUL'){
                this.layoutbotaoselecionado = `<button onclick="window.location.href='${window.location.origin}/webcheckinacesso/1'" title="Faça agora seu Checkin Digital"
                                        style="position: fixed;bottom: 20px;right: 30px;
                                        z-index: 9999;border: none;outline: none;background-color: #1560e5;color: white;
                                        cursor: pointer;padding: 15px;border-radius: 10px;height:4em;width:10em;
                                        display:flex;justify-content: center;align-items: center;">Fazer Check-In</button>`
            }

            if(cor == 'VERDE'){
                this.layoutbotaoselecionado = `<button onclick="window.location.href='${window.location.origin}/webcheckinacesso/1'" title="Faça agora seu Checkin Digital"
                                        style="position: fixed;bottom: 20px;right: 30px;
                                        z-index: 9999;border: none;outline: none;background-color: #15e57d;color: white;
                                        cursor: pointer;padding: 15px;border-radius: 10px;height:4em;width:10em;
                                        display:flex;justify-content: center;align-items: center;">Fazer Check-In</button>`
            }

            if(cor == 'VERMELHO'){
                this.layoutbotaoselecionado = `<button onclick="window.location.href='${window.location.origin}/webcheckinacesso/1'" title="Faça agora seu Checkin Digital"
                                        style="position: fixed;bottom: 20px;right: 30px;
                                        z-index: 9999;border: none;outline: none;background-color: #e51515;color: white;
                                        cursor: pointer;padding: 15px;border-radius: 10px;height:4em;width:10em;
                                        display:flex;justify-content: center;align-items: center;">Fazer Check-In</button>`
            }

        },
        salvar(){
            this.textobotaosalvar = "SALVANDO..."
            this.salvarExibicaoCovid().then(()=>{
                this.salvarExibicaoObservacao().then(()=>{
                    this.salvarExibicaoHorario().then(()=>{
                        this.salvarEmailAdm().then(()=>{
                            this.salvarEmailAdmSecundario().then(()=>{
                                this.salvarIdadeCrianca().then(()=>{
                                    this.salvarEstiloCor().then(()=>{
                                        this.salvarTextoWebCheckin().then(()=>{
                                            this.salvarTextoHorarioCheckinECheckout().then(()=>{
                                                this.salvarFinalizarFicha().then(() => {
                                                    this.salvarNecessidadeSelfie().then(()=>{
                                                        this.setModalPassosWebCheckin()
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        },
        salvarEstiloCor(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'WCHECKINESTILO',
                    "valor" :  this.$refs.corPrincipal.internalValue,
                    "valor2" : this.$refs.corSecundaria.internalValue,
                    "valor3" : this.$refs.corFundo.internalValue,
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarExibicaoCovid(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'WCHECKINEXIBIRCOVID',
                    "valor" : this.exibirPassosCovid
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarExibicaoObservacao(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'WCHECKINEXIBIROBS',
                    "valor" : this.exibirPassosObservacao
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarExibicaoHorario(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'WCHECKINEXIBIRHORARIO',
                    "valor" : this.exibirPassosHorario
                }).then(resp =>{
                    // if(resp.status == 200){
                    //     this.setModalPassosWebCheckin()
                    // }else{
                    //     alert("Não foi alterar os dados de exibição do termos")
                    // }
                    
                    if(localStorage.getItem('TIPOINTEGRACAO') == 'HITS'){
                        this.$http.post("configuracao/atualizarParametro", {  
                            "idhotel" : localStorage.getItem('hotel'),
                            "chave" : 'TIPOOBSERVACAO',
                            "valor" : this.obstipo.idnotetype
                        }).then(resp =>{
                            resolve(resp)
                        }).catch(error =>{
                            reject(error)
                            console.log(error)
                        })
                    }else{
                        resolve(resp)
                    }
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
        },
        salvarFinalizarFicha(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'WCHECKINFINALIZARFICHA',
                    "valor" : this.finalizarFicha
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
        },
        salvarEmailAdm(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'EMAILADMWEBCHECKIN',
                    "valor" : this.emailAdmWebCheckin
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarEmailAdmSecundario(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'EMAILADMWEBCHECKIN2',
                    "valor" : this.emailAdmWebCheckinSecundario
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarIdadeCrianca(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'IDADECRIANCAWEBCHECKIN',
                    "valor" : this.idadelimitecrianca
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarTextoWebCheckin(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'TEXTOWEBCHECKIN',
                    "valor" : this.assuntodowebcheckin,
                    "valor2" : this.textodowebcheckin
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarTextoHorarioCheckinECheckout(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'HORARIOPADRAOWEBCHECKIN',
                    "valor" : this.horariocheckin,
                    "valor2" : this.horariocheckout,
                    "valor3" : (this.infohorario.checkin != null && this.infohorario.checkin.trim() != '') ? this.infohorario.checkin : null,
                    "valor4" : (this.infohorario.checkout != null && this.infohorario.checkout.trim() != '') ? this.infohorario.checkout : null,
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
            
        },
        salvarNecessidadeSelfie(){
            return new Promise( (resolve,reject) =>{
                this.$http.post("configuracao/atualizarParametro", {  
                    "idhotel" : localStorage.getItem('hotel'),
                    "chave" : 'NECESSIDADESELFIE',
                    "valor" : this.necessidadeSelfie,
                }).then(resp =>{
                    resolve(resp)
                })
                .catch(error =>{
                    reject(error)
                    console.log(error)
                })
            })
        },
        setModalPassosWebCheckin(){
            this.textobotaosalvar = "SALVAR"
            this.$emit('setModalEditarPassosWebCheckin')
        },
    },
    mounted() {

        // this.tipointegracao = localStorage.getItem('TIPOINTEGRACAO');
         this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'TIPOINTEGRACAO'
            }).then(resp =>{
                if(resp.status == 200){
                    this.tipointegracao = resp.data[0].valor
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.layoutbotaoselecionado = `<button onclick="window.location.href='${window.location.origin}/webcheckinacesso/1'" title="Faça agora seu Checkin Digital"
                                        style="position: fixed;bottom: 20px;right: 30px;
                                        z-index: 9999;border: none;outline: none;background-color: #1560e5;color: white;
                                        cursor: pointer;padding: 15px;border-radius: 10px;height:4em;width:10em;
                                        display:flex;justify-content: center;align-items: center;">Fazer Check-In</button>`

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'WCHECKINESTILO'
            }).then(resp =>{
                if(resp.status == 200){
                    this.corPrincipal = JSON.parse(resp.data[0].valor)
                    this.corSecundaria = JSON.parse(resp.data[0].valor2)
                    this.corFundo = JSON.parse(resp.data[0].valor3)
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })
        
        //busca de dados 
        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'WCHECKINEXIBIROBS'
            }).then(resp =>{
                if(resp.status == 200){
                    this.exibirPassosObservacao = resp.data[0].valor == 'true' ? true : false
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

            
        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'WCHECKINEXIBIRCOVID'
            }).then(resp =>{
                if(resp.status == 200){
                    this.exibirPassosCovid = resp.data[0].valor == 'true' ? true : false
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'WCHECKINEXIBIRHORARIO'
            }).then(resp =>{
                if(resp.status == 200){
                    this.exibirPassosHorario = resp.data[0].valor == 'true' ? true : false
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'EMAILADMWEBCHECKIN'
            }).then(resp =>{
                if(resp.status == 200){
                    this.emailAdmWebCheckin = resp.data[0].valor
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'EMAILADMWEBCHECKIN2'
            }).then(resp =>{
                if(resp.status == 200){
                    this.emailAdmWebCheckinSecundario = resp.data[0].valor
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'IDADECRIANCAWEBCHECKIN'
            }).then(resp =>{
                if(resp.status == 200){
                    this.idadelimitecrianca = resp.data[0].valor
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'TEXTOWEBCHECKIN'
            }).then(resp =>{
                if(resp.status == 200){
                    this.assuntodowebcheckin = resp.data[0].valor
                    this.textodowebcheckin = resp.data[0].valor2
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

        this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'HORARIOPADRAOWEBCHECKIN'
            }).then(resp =>{
                if(resp.status == 200){
                    this.horariocheckin = resp.data[0].valor
                    this.horariocheckout = resp.data[0].valor2
                    this.infohorario = {
                      checkin: resp.data[0].valor3,
                      checkout: resp.data[0].valor4
                    }
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

            this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'WCHECKINFINALIZARFICHA'
            }).then(resp =>{
                if(resp.status == 200){
                    this.finalizarFicha = resp.data[0].valor == 'true' ? true : false
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

            this.$http.post("configuracao/buscarParametro", {  
                "idhotel" : localStorage.getItem('hotel'),
                "chave" : 'NECESSIDADESELFIE'
            }).then(resp =>{
                if(resp.status == 200){
                    this.necessidadeSelfie = resp.data[0].valor == 'true' ? true : false
                }else{
                    alert("Não foi possivel buscar os dados")
                }
            })
            .catch(error =>{
                console.log(error)
            })

            


            if(localStorage.getItem('TIPOINTEGRACAO') == 'HITS'){


                    this.$http.get("/integracao/getTipoObs/"+localStorage.getItem('TIPOINTEGRACAO')+"/"+localStorage.getItem('hotel')).then(resp =>{

                        if(resp.status == 200){
                        this.obstipos = resp.data
                        }else{
                            alert("Não foi possivel buscar os dados")
                        }

                    })
                    .catch(error =>{
                        alert(error)
                        console.log(error)
                    })

            

                    this.$http.post("configuracao/buscarParametro", {  
                        "idhotel" : localStorage.getItem('hotel'),
                        "chave" : 'TIPOOBSERVACAO'
                    }).then(resp =>{
                        
                        if(resp.status == 200){
                            this.obstipo = parseInt(resp.data[0].valor)
                        }else{
                            alert("Não foi possivel buscar os dados")
                        }
                    })
                    .catch(error =>{
                        console.log(error)
                    })


            }

            



    },
};
</script>


<style scoped>
/* Customize the label (the container) */
.inputcheckbox {
    height:200px;
}

  .inputs{
    background-color:white;
    border-radius:15px;
    min-height:8vh;
    padding:5px 20px 5px 20px;
    border: 1px solid #819ab4;
  }

  .cardInputs{
    display:flex;
    flex-direction:column;
    justify-content:left;
    width:100%;
    margin-bottom:20px;
    /* background-color:red; */
    
  }

  
  .inputsHorario{
    background-color:white;
    text-align:center;
    border-radius:15px;
    min-height:8vh;
    font-size:25px;
    padding:10px;
    /* padding:5px 20px 5px 20px; */
    border: 1px solid #819ab4;
    width:100px; 
    margin-right: 20px;
    margin-top:10px;    
    
  }
</style>